import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Personnal from "./components/Personnal";
import Security from "./components/Security";
import { Col, Row } from "react-bootstrap";
import Billing from "./components/Billing";
import ITabs from "@components/ITabs";

const Home = (props) => {
  const { t } = useTranslation();
  const [ActiveButton, setActiveButton] = useState("personnal");
  const handleActiveButton = (value) => {
    setActiveButton(value);
  };

  const InputSection = ({ title, description, input }) => (
    <Row className="align-items-center my-3">
      <Col lg="6" className="my-2">
        <div className="fs-6 text-dark fw-medium">{title}</div>
        <p className="fw-light">{description}</p>
      </Col>
      <Col lg="6" className="my-2">
        {input}
      </Col>
    </Row>
  );

  const buttons = [
    {
      title: t("personnal_informations"),
      value: "personnal",
      component: <Personnal {...props} InputSection={InputSection} t={t} />,
    },
    {
      title: t("connection_and_security"),
      value: "security",
      component: <Security {...props} InputSection={InputSection} t={t} />,
    },
    {
      title: t("billing_and_payment"),
      value: "billing",
      component: <Billing {...props} InputSection={InputSection} t={t} />,
    },
  ];

  return (
    <div
      className={`py-3 ${
        props.profile.mode === "dark" ? "text-white" : "text-dark"
      }`}
    >
      <div className="fs-3 fw-bold">{t("settings")}</div>
      <p className="my-1 fs-6 tetx-secondary fw-light">{t("settings_text")}</p>
      <section className="w-100 container my-4">
        <ITabs navItems={buttons} container={"home-forms"} selected={0} />
      </section>
    </div>
  );
};

export default Home;
